import { Badge } from "~/components/ui/badge"
import type { RouterOutputs } from "~/trpc/react"

export function AutomationStatusBadge({
	status
}: {
	status:
		| RouterOutputs["automations"]["runs"][number]["status"]
		| NonNullable<
				RouterOutputs["automations"]["runDetails"]
		  >["actions"][number]["status"]
}) {
	return (
		<Badge
			variant={
				status === "Succeeded"
					? "default"
					: status === "Failed" || status === "Partial"
						? "destructive"
						: "secondary"
			}
		>
			{status}
		</Badge>
	)
}
